import { Icon } from '@/components/foundations';
import { CopyToast } from '@/components/feedback/CopyToast';
import { useCopy } from './useCopy';

export type CopyFieldProps = {
  id: string;
  value: string;
  /** Rótulo acessível do botão (ex.: "Copiar endpoint"). Sem ele o campo não tem botão de copiar. */
  copyLabel?: string;
  /** Campo editável (ex.: ID do item Pluggy). Padrão: somente leitura. */
  editable?: boolean;
  onChange?: (value: string) => void;
  /** Texto copiado (padrão: o valor exibido). */
  copyValue?: string;
  /** Rótulo acessível do campo quando não há `<label htmlFor>` visível. */
  ariaLabel?: string;
};

/** Campo com botão de copiar (`.copyin`). O ícone fica verde por um instante ao copiar. */
export function CopyField({ id, value, copyLabel, editable = false, onChange, copyValue, ariaLabel }: CopyFieldProps) {
  const { copied, copy } = useCopy();
  return (
    <div className="copyin">
      {editable ? (
        <input id={id} aria-label={ariaLabel} defaultValue={value} onChange={(e) => onChange?.(e.target.value)} />
      ) : (
        <input id={id} aria-label={ariaLabel} readOnly value={value} />
      )}
      {copyLabel && (
        <button type="button" data-copy={id} onClick={() => copy(copyValue ?? value)} aria-label={copyLabel} style={copied ? { color: '#17996a' } : undefined}>
          <Icon name="copy" />
        </button>
      )}
      {copyLabel && <CopyToast show={copied} />}
    </div>
  );
}
